import React from 'react';
import Predicates from 'constants/predicates';
import Types from 'constants/types';

import PrimaryNumberEdit from './edit/PrimaryNumberEdit';
import SubNumberEdit from './edit/SubNumberEdit';
import ParentCollectionEdit from './edit/ParentCollectionEdit';
import IsParentCollectionEdit from './edit/IsParentCollectionEdit';
import ReferenceNumberEdit from './edit/ReferenceNumberEdit';
import AcquisitionCollectionEdit from './edit/AcquisitionCollectionEdit';
import AcquisitionSpecialCollectionEdit from './edit/AcquisitionSpecialCollectionEdit';
import AcquisitionEdit from './edit/AcquisitionEdit';
import ProceduralUnitsEdit from './edit/ProceduralUnitsEdit';
import ObjectLinkEdit from './edit/ObjectLinkEdit';
import AcquisitionObjectEdit from './edit/AcquisitionObjectEdit';
import OCMEdit from './edit/OCMEdit';
import UserEdit from './edit/UserEdit';
import IsIndenpendentCollectionEdit from './edit/IsIndenpendentCollectionEdit';
import LocationEdit from './edit/LocationEdit';
import ResourceWithGeometryEdit from './edit/ResourceWithGeometryEdit';
import BuiltSiteEdit from './edit/BuiltSiteEdit';
import BuiltSiteBuildingsEdit from './edit/BuiltSiteBuildingsEdit';
import SiteVisitEdit from './edit/SiteVisitEdit';
import ContributionEdit from './edit/ContributionEdit';
import StatementTextEdit from './edit/StatementTextEdit';

export default function SpectrumEdit(props) {
  const field = props.field;
  const type = field.type;
  
  if (!field) {
    return null;
  }

  // SPEC-121
  if (type === Types.SPECTRUM.GEOMETRY){
    return <LocationEdit field={field} />;
  }
  if (type === Types.SPECTRUM.PLACE_INFORMATION || type === Types.SPECTRUM.CE.SUB_SITE){
    return <ResourceWithGeometryEdit field={field} />;
  }
  
  switch (field.predicate) {
  // SPEC-1 + SPEC-40 identifier generation, link acquisition <-> object
  case Predicates.SPECTRUM.PRIMARY_NUMBER:
    return <PrimaryNumberEdit {...props} />;
    
  case Predicates.SPECTRUM.SUB_NUMBER:
    return <SubNumberEdit {...props} />;
      
  case Predicates.SPECTRUM.OBJECT_ACQUISITION_INFORMATION:
    return <AcquisitionEdit {...props} />;
       
  // SPEC-586 special collection
  case Predicates.SPECTRUM.ACQUISITION_SPECIAL_COLLECTION:
    return <AcquisitionSpecialCollectionEdit {...props} />;
      
  // SPEC-41 link collection <-> acquisition
  case Predicates.SPECTRUM.PARENT_COLLECTION:
    return <ParentCollectionEdit {...props} />;
    
  // SPEC-651
 case Predicates.SPECTRUM.IS_PARENT_COLLECTION:
    return <IsParentCollectionEdit {...props} />;
  
  case Predicates.SPECTRUM.REFERENCE_NUMBER:
    return <ReferenceNumberEdit {...props} />;

  case Predicates.SPECTRUM.IS_INDEPENDENT_COLLECTION:
    return <IsIndenpendentCollectionEdit {...props} />;
          
  case Predicates.SPECTRUM.ACQUISITION_COLLECTION:
    return <AcquisitionCollectionEdit {...props} />;

  // SPEC-86
  case Predicates.SPECTRUM.ACQUISITION_OBJECT:
    return <AcquisitionObjectEdit {...props} />;

  // SPEC-56
  case Predicates.SPECTRUM.CLASSIFICATION:
    return <OCMEdit {...props} />;
  
  // Cultural environment
  case Predicates.SPECTRUM.CE.LINK_TO_BUILT_SITE:
    return <BuiltSiteEdit {...props} />
  
  case Predicates.SPECTRUM.CE.BUILT_SITE_BUILDINGS:
    return <BuiltSiteBuildingsEdit {...props} />
  
  case Predicates.SPECTRUM.CE.SITE_VISIT:
    return <SiteVisitEdit {...props} />

  case Predicates.SPECTRUM.CE.CONTRIBUTION:
    return <ContributionEdit {...props} />
    
  case Predicates.SPECTRUM.CE.STATEMENT_TEXT:
    return <StatementTextEdit {...props} />
    
  case Predicates.SPECTRUM.CE.SOLVER:
    return <UserEdit {...props} />
    
  case Predicates.SPECTRUM.CE.DEMONSTRATOR:
    return <UserEdit {...props} />
    
  }
  if (field.props.proceduralUnitsSearch) {
    return <ProceduralUnitsEdit {...props} />;
  }
  else if (field.props.objectSearch) {
    return <ObjectLinkEdit {...props} />;
  }

  return null;
};